import _ from "lodash";

export interface ReformInfo<T, K extends keyof T, V> {
  key: keyof T;
  newKey: keyof V;
  replace: keyof T[K];
}
export const reform = <T, V>(value: T, reformList: ReformInfo<T, any, V>[]) => {
  const excludeKeys = _.map(reformList, (r) => r.key.toString());
  const includeKeys = _.difference(_.keys(value), excludeKeys);
  const newValue = {};
  _.forEach(includeKeys, (k) => _.set(newValue, k, _.get(value, k)));

  _.forEach(reformList, (reform) =>
    _.set(
      newValue,
      reform.newKey,
      _.get(value, reform.key) === null
        ? null
        : _.get(_.get(value, reform.key), reform.replace)
    )
  );

  return newValue as V;
};

export const reformId = <T, V>(value: T, reformKeys: (keyof T)[]) => {
  const reformList: Array<ReformInfo<T, any, V>> = [];
  for (const key of reformKeys) {
    reformList.push({
      key,
      newKey: (key.toString() + "_id") as keyof V,
      replace: "id" as any,
    });
    console.log("reforming", _.last(reformList));
  }
  return reform(value, reformList);
};

export const dejsonDeep = <T, V>(
  value: T,
  reformMap: { [key in keyof V]?: Array<String> }
) => {
  const excludeKeys = _.keys(reformMap);
  const includeKeys = _.difference(_.keys(value), excludeKeys);
  const newValue = {};
  _.forEach(includeKeys, (k) => _.set(newValue, k, _.get(value, k)));

  _.keys(reformMap).forEach((topLevelKey) => {
    const val = _.get(value, topLevelKey);
    const reformKeys = _.get(reformMap, topLevelKey);

    if (_.isArray(val)) {
      _.set(
        newValue,
        topLevelKey,
        _.map(val, (v) => dejson(v, reformKeys))
      );
    } else {
      _.set(newValue, topLevelKey, dejson(val, reformKeys));
    }
  });

  return newValue as V;
};

export const dejson = <T, V>(value: T, keys: string[]) => {
  const excludeKeys = keys;
  const includeKeys = _.difference(_.keys(value), excludeKeys);
  const newValue = {};
  _.forEach(includeKeys, (k) => _.set(newValue, k, _.get(value, k)));

  _.forEach(keys, (reform) => {
    const item = _.get(value, reform);
    if (typeof item === "string") {
      try {
        const obj = JSON.parse(item);
        _.set(newValue, reform, obj);
      } catch {}
    } else if (typeof item === "object") {
      _.set(newValue, reform, item);
    }
  });

  return newValue as V;
};

export const jsonStringify = <T, V>(value: T, keys: (keyof T)[]) => {
  const excludeKeys = keys as string[];
  const includeKeys = _.difference(_.keys(value), excludeKeys);

  const newValue = {};
  _.forEach(includeKeys, (k) => _.set(newValue, k, _.get(value, k)));

  _.forEach(keys, (reform) => {
    const item = _.get(value, reform);
    if (typeof item !== "string") _.set(newValue, reform, JSON.stringify(item));
    else _.set(newValue, reform, item);
  });
  return newValue as V;
};
